// index.tsx
import { ReactNode, useCallback, FC } from 'react';
import { mdiAlertCircleOutline, mdiCheckCircle } from '@mdi/js';
import { CheckCircleIcon, AlertCircleOutlineIcon, Container, Text} from './styles'
import { ToastType } from '../../enums/toast';

export interface ToastProps {
    children: ReactNode;
    type: ToastType;
    className: string | undefined;
}

const Toast: FC<ToastProps> = ({children, className, type = ToastType.ERROR}) => {
    const renderIcon = useCallback((): ReactNode => {
        switch (type) {
            case ToastType.SUCCESS:
                return <CheckCircleIcon icon={mdiCheckCircle} type={type} />;
            default:
                return <AlertCircleOutlineIcon icon={mdiAlertCircleOutline} type={type} />;
        }
    }, [type]);

    return (
        <Container className={className} type={type}>
            {renderIcon()}
            <Text>{children}</Text>
        </Container>
  );
};

export default Toast;
